import * as React from 'react';
import { BalanceDesktopContainer } from '../BalanceDesktop';
import { CheckoutContainer } from '../Checkout';
import { ActionButtonsDesktop } from '../ActionButtonsDesktop';
import * as styles from './SummaryDesktop.css';
import { VisibleViolationsWarningContainer } from '../VisibleViolationsWarning';

export const SummaryDesktop = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['left']}>
        <BalanceDesktopContainer />
      </div>

      <div className={styles['right']}>
        <CheckoutContainer />

        <VisibleViolationsWarningContainer />

        <ActionButtonsDesktop />
      </div>
    </div>
  );
};
